import React from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useFormContext } from '../../contexts/FormContext';
import { Modal, Button } from 'react-bootstrap';
import useUnreadCount from '../../hooks/useUnreadCount';
import { useAuth } from '../../contexts/AuthContext';
import NotificationBell from './NotificationBell';
import OwnerNotificationBell from './OwnerNotificationBell';
import RenterNotificationBell from './RenterNotificationBell';

export default function AppHeader({ onSidebarToggle }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { isFormDirty, formType, formMessage } = useFormContext();
  const [showConfirmModal, setShowConfirmModal] = React.useState(false);
  const [pendingNavigation, setPendingNavigation] = React.useState(null);
  const unreadCount = useUnreadCount();
  const { userRole } = useAuth();

  const goBack = () => {
    if (isFormDirty && (formType === 'boat' || formType === 'payment')) {
      setPendingNavigation({ type: 'back' });
      setShowConfirmModal(true);
    } else {
      navigate(-1); // Navigate back one step in history
    }
  };

  const handleConfirmNavigation = () => {
    setShowConfirmModal(false);
    if (pendingNavigation) {
      if (pendingNavigation.type === 'back') {
        navigate(-1);
      } else if (pendingNavigation.type === 'link') {
        navigate(pendingNavigation.to);
      }
      setPendingNavigation(null);
    }
  };

  const handleCancelNavigation = () => {
    setShowConfirmModal(false);
    setPendingNavigation(null);
  };

  const handleLinkClick = (to, e) => {
    if (isFormDirty && (formType === 'boat' || formType === 'payment')) {
      e.preventDefault();
      setPendingNavigation({ type: 'link', to });
      setShowConfirmModal(true);
    }
  };

  const openSidebar = () => {
    console.log('Clicked');
    onSidebarToggle();
  };

  return (
    <>
      <nav className="navbar navbar-light navbar-expand-lg">
        <div className="container-fluid">
          <div className="navbar-nav" id="navbarNav">
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link
                  className="nav-link hide-sidebar-toggle-button"
                  to="#"
                  onClick={goBack}
                >
                  <i className="material-icons">first_page</i>
                </Link>
              </li>
              <li className="nav-item mobile-only">
                <Link
                  className="nav-link hide-sidebar-toggle-button"
                  onClick={openSidebar}
                >
                  <i className="material-icons">menu_open</i>
                </Link>
              </li>
            </ul>
          </div>
          <div className="d-flex">
            <ul className="navbar-nav">
              <li className="nav-item hidden-on-mobile">
                <Link
                  to="/"
                  className={`nav-link text-black ${location.pathname === "/" ? "active" : ""
                    }`}
                  onClick={(e) => handleLinkClick('/', e)}
                >
                  <span className="text-black">Back to website</span>
                </Link>
              </li>
              <li className="nav-item hidden-on-mobile">
                <Link
                  to="/dashboard/inbox"
                  className={`nav-link text-black ${location.pathname === "/dashboard/inbox" ? "active" : ""
                    }`}
                  onClick={(e) => handleLinkClick('/dashboard/inbox', e)}
                >
                  <span className="text-black d-flex align-items-center">
                    Inbox
                    {unreadCount > 0 && (
                      <span
                        className="ms-2"
                        style={{
                          backgroundColor: '#ff4d4f',
                          color: '#fff',
                          borderRadius: '50%',
                          minWidth: '24px',
                          height: '24px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontWeight: 'bold',
                          fontSize: '14px',
                          padding: '0 6px'
                        }}
                      >
                        {unreadCount}
                      </span>
                    )}
                  </span>
                </Link>
              </li>
              <li className="nav-item hidden-on-mobile">
                <Link
                  to="/dashboard/bookings"
                  className={`nav-link text-black ${location.pathname === "/dashboard/bookings" ? "active" : ""
                    }`}
                  onClick={(e) => handleLinkClick('/dashboard/bookings', e)}
                >
                  <span>Bookings</span>
                </Link>
              </li>
              <li className="nav-item hidden-on-mobile">
                <Link
                  to="/dashboard/payments"
                  className={`nav-link text-black ${location.pathname === "/dashboard/payments" ? "active" : ""
                    }`}
                  onClick={(e) => handleLinkClick('/dashboard/payments', e)}
                >
                  <span>Payments</span>
                </Link>
              </li>
              {userRole === "Admin" && <NotificationBell />}
              {userRole === "Boat Owner" && <OwnerNotificationBell />}
              {userRole === "Renter" && <RenterNotificationBell />}
            </ul>
          </div>
        </div>
      </nav>
      {/* Confirmation Modal */}
      <Modal show={showConfirmModal} onHide={handleCancelNavigation} centered>
        <Modal.Header closeButton>
          <Modal.Title>{formType === 'payment' ? 'Pending Payment' : 'Unsaved Changes'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {formMessage || 'You have unsaved changes in your boat form. If you navigate away, all your data will be lost. Do you want to continue?'}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelNavigation}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirmNavigation}>
            Continue
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
